import React from 'react';
import styled from 'styled-components/native';

import { EWebtraderResetPasswordType } from '@webtrader/core/api/config/company';
import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { useCompany } from '@webtrader/core/services/company';

import Text from '@/components/Text';
import { ALL_MOBILE_ROUTES, navigate } from '@/utils/navigation';
import { openInAppBrowser } from '@/utils/web';

interface IResetPasswordLinkProps {
  isLive?: boolean;
}

const ResetPasswordLink: FCC<IResetPasswordLinkProps> = ({ isLive = false }) => {
  const { t } = useTranslation();
  const { company } = useCompany();
  const { webtraderResetPasswordType, webtraderResetPasswordUrl, crmForgotPasswordType, crmForgotPasswordUrl } =
    company || {};

  const handleForgotPasswordClick = () => {
    if (isLive) {
      switch (crmForgotPasswordType) {
        case EWebtraderResetPasswordType.INTEGRATION:
          navigate(ALL_MOBILE_ROUTES.AUTH.RESET_PASSWORD, { isLive });
          return;
        case EWebtraderResetPasswordType.REDIRECTION:
          openInAppBrowser(crmForgotPasswordUrl);
          return;
        default:
          return;
      }
    } else {
      // MT4 / MT5
      switch (webtraderResetPasswordType) {
        case EWebtraderResetPasswordType.INTEGRATION:
          navigate(ALL_MOBILE_ROUTES.AUTH.RESET_PASSWORD, { isLive });
          return;
        case EWebtraderResetPasswordType.REDIRECTION:
          openInAppBrowser(webtraderResetPasswordUrl);
          return;
        default:
          return;
      }
    }
  };

  return (
    <StyledLinkContainer>
      <StyledLink onPress={handleForgotPasswordClick} testID={EDataTestId.RESET_PASSWORD_LINK}>
        {t('Forgot password?')}
      </StyledLink>
    </StyledLinkContainer>
  );
};

export default ResetPasswordLink;

const StyledLinkContainer = styled.View`
  align-items: center;
`;

const StyledLink = styled(Text)`
  font-size: ${dynamicSize.convertSize(14)}px;
  color: ${({ theme }) => theme.colors.primary};
`;
